import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { VolumeIcon } from "../Icons";

function Sidebar() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(() => window.innerWidth >= 770);
  const narrationLinkIsActive =
    pathname.startsWith("/narrations") ||
    (pathname.startsWith("/narration/") && pathname.split("/").length === 3);
  const reciterLinkIsActive =
    pathname.startsWith("/reciter/") ||
    (pathname.startsWith("/narration/") && pathname.split("/").length === 4);

  const handleMenuClick = () => {
    if (window.innerWidth < 770) {
      setOpen(false);
    }
  };

  return (
    <>
      {/* MOBILE TOGGLE BUTTON */}
      <button className="mobile-toggle" onClick={() => setOpen(true)}>
        ☰
      </button>

      {open && (
        <div className="sidebar-overlay" onClick={() => setOpen(false)} />
      )}

      <aside className={`sidebar ${open ? "open" : "closed"}`}>
        {/* SIDEBAR HEADER */}
        <div className="sidebar-header">
          {/* Toggle button on the LEFT */}
          <button
            className="sidebar-toggle"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Close sidebar" : "Open sidebar"}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
              width="24"
              focusable="false"
              aria-hidden="true"
            >
              <path d="M20 5H4a1 1 0 000 2h16a1 1 0 100-2Zm0 6H4a1 1 0 000 2h16a1 1 0 000-2Zm0 6H4a1 1 0 000 2h16a1 1 0 000-2Z"></path>
            </svg>
          </button>

          {/* Logo on the RIGHT */}
          {open && (
            <div className="sidebar-logo">
              <NavLink to="/" className="link" onClick={handleMenuClick}>
                <span className="logo-text">AFLAX</span>
              </NavLink>
            </div>
          )}
        </div>

        {/* MENU */}
        <nav className="sidebar-menu">
          <NavLink
            to="/"
            className={`menu-item ${reciterLinkIsActive ? "active" : ""}`}
            onClick={handleMenuClick}
          >
            🏠 {open && "Qur'an Recitations"}
          </NavLink>

          <NavLink
            to="/taraweeh"
            className="menu-item"
            onClick={handleMenuClick}
          >
            <VolumeIcon /> {open && "Recitations from Haramain"}
          </NavLink>

          <NavLink
            to="/narrations"
            className={`menu-item ${narrationLinkIsActive ? "active" : ""}`}
            onClick={handleMenuClick}
          >
            <VolumeIcon /> {open && "Qur'an Narrations"}
          </NavLink>

          <NavLink to="/dua" className="menu-item" onClick={handleMenuClick}>
            <VolumeIcon /> {open && "Du'a"}
          </NavLink>
        </nav>
      </aside>
    </>
  );
}

export default Sidebar;
